/* Copied from prototype/terms.html by tools/port-page.py. */
(function () {
  "use strict";

  /* The bar's cup still says which model you are in, the same as on every other
     page. It reads the visit's own model and falls back to OKKO, the studio's
     best seller, exactly as the home page does - this page keeps no copy of its
     own, so the two cannot drift. */
  var name = 'OKKO';
  try {
    var saved = sessionStorage.getItem('odaka.model');
    if (saved) name = saved;
  } catch (e) {}

  document.getElementById('forms-mark').innerHTML = window.ODAKA_SIL(name);
  document.getElementById('forms-btn').href =
    '/?screen=explore&m=' + window.ODAKA_SLUG(name);

  /* The footer's tally is written by the footer itself (sections/footer.liquid),
     from Shopify, 31-10-2026. */
})();


/* ---------- WE / ARE / ODAKA: outlines, inked in under the pointer ----------
   Two jobs in one place.

   THE LAYOUT. The words are SVG so they can fill the measure at any width, and
   everything about their size is MEASURED off the face rather than written
   down. The script sets a reference size, asks ODAKA - the longest of the three
   - how wide its ink actually is, and scales until that is exactly the stage.
   Then it asks how tall a capital is and uses that as the distance between
   baselines, which is what makes the rows touch: a line box is always taller
   than the capitals inside it, so any ordinary line-height leaves a gap. Both
   figures come from the browser, so a change of face or of weight cannot leave
   a hard-coded number behind.

   THE INK. Lifted from Web Effects/Ink Reveal with David's own settings, 15 Sep
   2026. The filled words sit behind a mask; the mask is a soft-edged circle
   that follows the pointer, and one filter tears its edge - fractal noise, a
   displacement, a hair of blur, then a threshold on alpha so the tear comes out
   crisp rather than smoky. `color-interpolation-filters="sRGB"` is not
   optional: in the default linearRGB the noise is read differently and the
   whole word shifts sideways.

   With nobody there it wanders. A phone has no pointer, and without the wander
   the words on a phone would be outlines and nothing else - the effect would
   simply not exist on the device the brief is written for. */
(function () {
  var svg = document.getElementById('title-ink');
  if (!svg) return;
  var W = 1000, H = 700;
  var tip = document.getElementById('ti-tip');
  var off = document.getElementById('ti-off');
  var disp = document.getElementById('ti-disp');
  var mask = document.getElementById('ti-brush');
  var filt = document.getElementById('ti-ink');
  var measure = svg.querySelector('.ti-measure');
  var outline = svg.querySelector('.ti-outline');
  var probe = measure.querySelector('[data-w="odaka"]');
  var lines = svg.querySelectorAll('.ti-line');
  var WM = window.ODAKA_WORDMARK;

  /* David's settings, copied off the Ink Reveal panel rather than re-tuned. */
  var BRUSH = 120,      /* the circle's radius, in stage units */
      ALIVE = 26,       /* how far the noise slides under it; 2.4x this is the swing */
      DELAY = 520,      /* ms: the ink goes where the pointer WAS */
      FOLLOW0 = 0.03, FOLLOW = 0.1, RAMP = 2,   /* starts sluggish, wakes up */
      GROW = 0.12;

  function layout() {
    var F = 200;
    svg.style.fontSize = F + 'px';
    var bb = probe.getBBox();
    if (!bb.width || !bb.height) return false;   /* the face has not landed yet */

    F = F * W / bb.width;
    svg.style.fontSize = F + 'px';

    /* ⚠️ A capital's height comes from the FONT FILE, not from getBBox.
       getBBox on SVG text answers with the em box - ascender to descender - not
       the ink. Measured that way the cap came out as 0.97em instead of 0.72em,
       which put a 70-unit gap between every row and meant the words never
       touched, however often that was claimed. wordmark.js carries the real
       sCapHeight, so the rows can close up properly. */
    var cap = WM ? WM.cap * F / WM.em : -probe.getBBox().y;
    if (!(cap > 0)) return false;
    /* The stroke is one screen pixel and is set in CSS, so the only thing the
       stage needs is a hair of room for the half of it that falls outside the
       path. In stage units that is under a unit at any size worth drawing. */
    var pad = 2;

    H = Math.round(cap * 3 + pad * 2);
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    mask.setAttribute('height', H);
    filt.setAttribute('height', H + 240);

    /* Baselines one cap apart, so the rows touch. Then each word is nudged so
       its INK starts at zero - left-aligned by what you can see, not by the
       advance, which is a different edge when the tracking is negative. */
    for (var i = 0; i < lines.length; i++) {
      var el = lines[i], row = i % 3;
      el.setAttribute('x', 0);
      el.setAttribute('y', (pad + cap * (row + 1)).toFixed(2));
      var r = el.getBBox();
      el.setAttribute('x', (-r.x).toFixed(2));
    }

    /* ---- the two rows above ODAKA are set against the row beneath them ----
       David, 15 Sep 2026: "move ARE so the R edge will touch D edge", and "move
       the WE so the W left part will sit nicely on top of the A".

       Both are computed from where the letters actually fall, asked of the
       browser one character at a time, so they hold at every width and survive
       a change of face or of tracking. Typing the two numbers in would put them
       right on this screen and wrong on the next one.

       ARE is exact: the R's left edge goes onto the D's left edge, so the two
       stems run on through the rows. WE carries the one judged figure on the
       page - a W's left vertex sits about this far into its own width, and the
       A's peak is halfway across the A - so it is named and alone rather than
       buried in a magic number. */
    var W_VERTEX = 0.27, A_PEAK = 0.5;

    var odaka = measure.querySelector('[data-w="odaka"]');
    var are = measure.querySelector('[data-w="are"]');
    var we = measure.querySelector('[data-w="we"]');

    var dAre = charX(odaka, 1) - charX(are, 1);
    shift(1, dAre);

    var aBox = are.getExtentOfChar(0);
    var wBox = we.getExtentOfChar(0);
    shift(0, (aBox.x + aBox.width * A_PEAK) - (wBox.x + wBox.width * W_VERTEX));

    drawOutline(F);
    return true;
  }

  /* One merged path per letter, laid where the hidden text says that letter
     falls. The shapes come from tools/build-wordmark.py; the POSITIONS come
     from the browser, so kerning and the negative tracking stay whatever the
     CSS says they are. */
  function drawOutline(F) {
    while (outline.firstChild) outline.removeChild(outline.firstChild);
    if (!WM) return;
    var k = F / WM.em;
    for (var i = 0; i < 3; i++) {
      var t = measure.children[i];
      var word = t.textContent.toUpperCase();
      var y = parseFloat(t.getAttribute('y'));
      for (var c = 0; c < word.length; c++) {
        var d = WM.glyphs[word[c]];
        if (!d) continue;
        var at = t.getStartPositionOfChar(c);
        var el = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        el.setAttribute('d', d);
        el.setAttribute('transform', 'translate(' + at.x.toFixed(2) + ' ' + y.toFixed(2) +
                        ') scale(' + k.toFixed(5) + ')');
        outline.appendChild(el);
      }
    }
  }

  function charX(el, i) { return el.getExtentOfChar(i).x; }

  /* the same nudge to both copies of a row: the outline and the fill are two
     sets of text, and they have to stay on top of one another exactly */
  function shift(row, dx) {
    for (var i = row; i < lines.length; i += 3) {
      lines[i].setAttribute('x', (parseFloat(lines[i].getAttribute('x')) + dx).toFixed(2));
    }
  }

  /* ---- the brush ---- */
  var pt = { x: W / 2, y: H / 2, r: 0, tx: W / 2, ty: H / 2, tr: 0,
             over: false, last: 0, t0: performance.now(), since: 0 };
  var hist = [];
  function note(x, y, over, now) { hist.push({ x: x, y: y, over: over, t: now }); if (hist.length > 600) hist.shift(); }
  function delayed(now) {
    var want = now - DELAY, i = hist.length - 1;
    if (i < 0) return null;
    while (i > 0 && hist[i].t > want) i--;
    var a = hist[i], b = hist[i + 1];
    if (!b || a.t >= want || !a.over || !b.over) return a.t <= want || i === 0 ? a : b;
    var f = (want - a.t) / (b.t - a.t || 1);
    return { x: a.x + (b.x - a.x) * f, y: a.y + (b.y - a.y) * f, over: true, t: want };
  }
  function toStage(ev) {
    var r = svg.getBoundingClientRect();
    return { x: (ev.clientX - r.left) / r.width * W, y: (ev.clientY - r.top) / r.height * H };
  }
  svg.addEventListener('pointermove', function (ev) { var p = toStage(ev), n = performance.now(); note(p.x, p.y, true, n); pt.last = n; });
  svg.addEventListener('pointerenter', function (ev) { var p = toStage(ev), n = performance.now(); note(p.x, p.y, false, n - 1); note(p.x, p.y, true, n); pt.last = n; });
  svg.addEventListener('pointerleave', function (ev) { var p = toStage(ev), n = performance.now(); note(p.x, p.y, false, n); pt.last = n; });
  /* a finger that lifts fires no pointerleave, so its last touch counts as leaving */
  svg.addEventListener('pointerup', function (ev) { if (ev.pointerType !== 'mouse') { var p = toStage(ev); note(p.x, p.y, false, performance.now()); } });

  function frame(now) {
    var s0 = now / 1000;
    off.setAttribute('dx', (ALIVE * 1.6 * Math.sin(s0 * 0.50) + ALIVE * 0.8 * Math.sin(s0 * 1.30 + 2)).toFixed(1));
    off.setAttribute('dy', (ALIVE * 1.6 * Math.cos(s0 * 0.41) + ALIVE * 0.8 * Math.sin(s0 * 1.10)).toFixed(1));
    disp.setAttribute('scale', (144 * (1 + 0.06 * Math.sin(s0 * 1.7))).toFixed(2));

    var d0 = delayed(now), was = pt.over, idle = now - pt.last;
    if (d0) { pt.over = d0.over; if (d0.over) { pt.tx = d0.x; pt.ty = d0.y; } }
    if (pt.over && !was) pt.since = now;
    if (pt.over) { pt.tr = BRUSH; }
    else if (idle > 1500 + DELAY) {
      var t = (now - pt.t0) / 1000;
      pt.tx = W / 2 + (W / 2 - 80) * Math.sin(t * 0.21);
      pt.ty = H / 2 + H * 0.34 * Math.sin(t * 0.37 + 1);
      pt.tr = BRUSH * 0.8;
    } else { pt.tr = 0; }
    if (pt.r < 1 && pt.over) { pt.x = pt.tx; pt.y = pt.ty; }
    var k = Math.min(1, (now - pt.since) / (RAMP * 1000));
    var follow = FOLLOW0 + (FOLLOW - FOLLOW0) * k * k * (3 - 2 * k);
    pt.x += (pt.tx - pt.x) * follow;
    pt.y += (pt.ty - pt.y) * follow;
    pt.r += (pt.tr - pt.r) * GROW;
    tip.setAttribute('cx', pt.x.toFixed(1));
    tip.setAttribute('cy', pt.y.toFixed(1));
    tip.setAttribute('r', pt.r.toFixed(1));
    requestAnimationFrame(frame);
  }

  function start() { if (!layout()) setTimeout(start, 60); }
  start();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
  addEventListener('resize', layout);
  requestAnimationFrame(frame);
})();
